import type { TipoMoneda } from '@/types/costo';

/**
 * Formato monetario del sistema: es-AR con 2 decimales para ambas monedas.
 * No hay conversión entre monedas ni totales combinados.
 */
export const formatearMonto = (monto: number, moneda: TipoMoneda = 'ARS'): string =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: moneda,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(monto);

export const formatearFecha = (fecha?: string | null): string => {
  if (!fecha) return '—';

  return new Intl.DateTimeFormat('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(fecha));
};
